
import Entity from '../entity'
import Address from '../address'

export default class CreateCustomer extends Entity<number>{
    code:string;
    name: string;
    phone:string;
    taxNumber: string;
    type: string;
    receiver: string;
    address: Address=new Address();
    tplCodes: Array<string>;
    defaultTPLCode:string;
}